import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import openai from '../../../services/openaiClient';

const MaintenanceAlertActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('active');
  const [aiQuery, setAiQuery] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [isLoadingAI, setIsLoadingAI] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState('');
  const [maintenanceType, setMaintenanceType] = useState('');
  const [priority, setPriority] = useState('medium');
  const [scheduledDate, setScheduledDate] = useState('');

  const handleAIMaintenanceAdvice = async () => {
    setIsLoadingAI(true);
    try {
      const completion = await openai?.chat?.completions?.create({
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'أنت مساعد ذكي متخصص في إدارة الصيانة والأعمال الفنية للعقارات. قدم نصائح عملية لإدارة طلبات الصيانة.'
          },
          {
            role: 'user',
            content: aiQuery || 'كيف أدير طلبات الصيانة العاجلة بكفاءة؟'
          }
        ],
        temperature: 0.7,
        max_tokens: 500
      });
      
      setAiResponse(completion?.choices?.[0]?.message?.content || 'لم يتم الحصول على رد');
    } catch (error) {
      console.error('AI Analysis Error:', error);
      setAiResponse('حدث خطأ في تحليل الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoadingAI(false);
    }
  };

  const handleCreateWorkOrder = () => {
    if (!selectedProperty || !maintenanceType || !scheduledDate) {
      alert('يرجى ملء جميع الحقول المطلوبة');
      return;
    }
    console.log('Creating work order:', { selectedProperty, maintenanceType, priority, scheduledDate });
    alert('تم إنشاء أمر العمل بنجاح');
  };

  const tabs = [
    { id: 'active', label: 'الطلبات النشطة', icon: 'AlertCircle' },
    { id: 'create', label: 'إنشاء أمر عمل', icon: 'Plus' },
    { id: 'ai-advice', label: 'نصائح ذكية', icon: 'Lightbulb' }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="تنبيهات الصيانة"
      icon="Wrench"
      iconColor="#06B6D4"
      size="xl"
      footer={null}
    >
      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-border">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' :'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'active' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">طلبات الصيانة النشطة</h3>
            
            <div className="space-y-3">
              <div className="p-4 border-l-4 border-red-500 bg-red-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-red-900">WO-2026-089</h4>
                    <p className="text-sm text-red-700">تسرب مياه - شقة 305، برج السلام</p>
                  </div>
                  <span className="px-2 py-1 bg-red-200 text-red-800 text-xs rounded font-semibold">عاجل</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-red-700 mb-2">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    تم الإبلاغ: ٢٠٢٦/٠١/١٠
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    فني: أحمد الصيانة
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline">
                    <span className="flex items-center gap-1">
                      <Icon name="CheckCircle" size={14} />
                      إكمال
                    </span>
                  </Button>
                  <Button size="sm" variant="outline">
                    <span className="flex items-center gap-1">
                      <Icon name="Phone" size={14} />
                      اتصال
                    </span>
                  </Button>
                </div>
              </div>

              <div className="p-4 border-l-4 border-orange-500 bg-orange-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-orange-900">WO-2026-092</h4>
                    <p className="text-sm text-orange-700">صيانة مكيف - فيلا 12، حي الملقا</p>
                  </div>
                  <span className="px-2 py-1 bg-orange-200 text-orange-800 text-xs rounded font-semibold">عالي</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-orange-700 mb-2">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    مجدول: ٢٠٢٦/٠١/١١
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    فني: محمد الكهرباء
                  </span>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline">
                    <span className="flex items-center gap-1">
                      <Icon name="Edit" size={14} />
                      تعديل
                    </span>
                  </Button>
                </div>
              </div>

              <div className="p-4 border-l-4 border-blue-500 bg-blue-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-blue-900">WO-2026-095</h4>
                    <p className="text-sm text-blue-700">صيانة دورية - مكتب تجاري، الشميساني</p>
                  </div>
                  <span className="px-2 py-1 bg-blue-200 text-blue-800 text-xs rounded font-semibold">متوسط</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-blue-700">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    مجدول: ٢٠٢٦/٠١/١٥
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    فني: سارة الصيانة
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-4 mt-6">
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-red-600">8</p>
                <p className="text-xs text-red-700">عاجل</p>
              </div>
              <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-orange-600">15</p>
                <p className="text-xs text-orange-700">عالي</p>
              </div>
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-blue-600">23</p>
                <p className="text-xs text-blue-700">متوسط</p>
              </div>
              <div className="p-3 bg-green-50 border border-green-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-green-600">42</p>
                <p className="text-xs text-green-700">مكتمل</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'create' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">إنشاء أمر عمل جديد</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">العقار</label>
                <select
                  value={selectedProperty}
                  onChange={(e) => setSelectedProperty(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="">-- اختر عقار --</option>
                  <option value="prop-1">شقة 305، برج السلام</option>
                  <option value="prop-2">فيلا 12، حي الملقا</option>
                  <option value="prop-3">مكتب تجاري، الشميساني</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">نوع الصيانة</label>
                <select
                  value={maintenanceType}
                  onChange={(e) => setMaintenanceType(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="">-- اختر نوع الصيانة --</option>
                  <option value="plumbing">سباكة</option>
                  <option value="electrical">كهرباء</option>
                  <option value="ac">تكييف</option>
                  <option value="painting">دهان</option>
                  <option value="carpentry">نجارة</option>
                  <option value="general">صيانة عامة</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">الأولوية</label>
                <select
                  value={priority}
                  onChange={(e) => setPriority(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="urgent">عاجل</option>
                  <option value="high">عالي</option>
                  <option value="medium">متوسط</option>
                  <option value="low">منخفض</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">تاريخ الجدولة</label>
                <Input
                  type="date"
                  value={scheduledDate}
                  onChange={(e) => setScheduledDate(e?.target?.value)}
                  className="w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">وصف المشكلة</label>
                <textarea
                  placeholder="اكتب وصفاً تفصيلياً للمشكلة..."
                  rows={4}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background resize-none"
                />
              </div>

              <Button
                onClick={handleCreateWorkOrder}
                className="w-full"
                variant="primary"
              >
                <span className="flex items-center gap-2">
                  <Icon name="Plus" size={18} />
                  إنشاء أمر العمل
                </span>
              </Button>
            </div>

            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div className="flex items-start gap-2">
                <Icon name="Info" size={20} className="text-blue-600 mt-1" />
                <div>
                  <h4 className="font-semibold text-blue-900 mb-1">نصيحة</h4>
                  <p className="text-sm text-blue-800">
                    تأكد من تحديد الأولوية بدقة. الطلبات العاجلة يتم معالجتها خلال 24 ساعة.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'ai-advice' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">نصائح ذكية لإدارة الصيانة</h3>
            
            <div className="space-y-3">
              <label className="block text-sm font-medium">اسأل عن إدارة الصيانة</label>
              <Input
                value={aiQuery}
                onChange={(e) => setAiQuery(e?.target?.value)}
                placeholder="مثال: كيف أحدد أولويات طلبات الصيانة المتعددة؟"
                className="w-full"
              />
              <Button
                onClick={handleAIMaintenanceAdvice}
                disabled={isLoadingAI}
                className="w-full"
              >
                {isLoadingAI ? (
                  <span className="flex items-center gap-2">
                    <Icon name="Loader" size={18} className="animate-spin" />
                    جاري التحليل...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Icon name="Lightbulb" size={18} />
                    احصل على نصائح
                  </span>
                )}
              </Button>
            </div>

            {aiResponse && (
              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start gap-2 mb-2">
                  <Icon name="Sparkles" size={20} className="text-blue-600 mt-1" />
                  <h4 className="font-semibold text-blue-900">نصائح الذكاء الاصطناعي</h4>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{aiResponse}</p>
              </div>
            )}

            <div className="mt-6 p-4 bg-muted/30 rounded-lg">
              <h4 className="font-semibold mb-3 flex items-center gap-2">
                <Icon name="CheckCircle" size={18} className="text-green-600" />
                أفضل ممارسات الصيانة
              </h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>الاستجابة للطلبات العاجلة خلال ساعة واحدة</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>جدولة الصيانة الدورية لتجنب الأعطال</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>توثيق جميع أعمال الصيانة بالصور</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>متابعة رضا العميل بعد إتمام العمل</span>
                </li>
              </ul>
            </div>

            <div className="grid grid-cols-2 gap-4 mt-4">
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Clock" size={24} className="text-blue-600 mb-2" />
                <h4 className="font-semibold mb-1">صيانة وقائية</h4>
                <p className="text-sm text-muted-foreground">جدولة منتظمة لتجنب المشاكل</p>
              </div>
              
              <div className="p-4 border border-border rounded-lg">
                <Icon name="Zap" size={24} className="text-orange-600 mb-2" />
                <h4 className="font-semibold mb-1">استجابة سريعة</h4>
                <p className="text-sm text-muted-foreground">معالجة فورية للطوارئ</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MaintenanceAlertActionsModal;